<template>
  <SectionTemplate
    title="仅需2步操作，轻松打造您的专属智能体"
    desc="无需代码，轻松上手。仅需2步完成，一个可讲解、可问答的智能数字人即刻为您服务。"
    class="tow-steps"
  >
    <div class="tow-steps__feature">
      <EditCard v-for="(feat, index) in featureList" :key="index" :data="feat" />
    </div>

    <div class="mt-[80px]">
      <StartBtn
        :widthStyle="{ width: '178px', height: '48px' }"
        :handler="handler"
        text="立即体验"
      />
    </div>
  </SectionTemplate>
</template>

<script lang="ts" setup>
import StartBtn from '~/design/components/buttons/start-btn.vue';
import EditCard from '~/design/components/edit-card/index.vue';
import SectionTemplate from '~/design/widgets/landing-section/cn-template.vue';

const featureList = [
  {
    title: '步骤一：创建PPT',
    des: '上传本地PPT或使用AIPPT功能创建PPT项目',
    path: getFeUrl('/youyan-platform/chat-ppt/tools/1.png?x-oss-process=image/format,webp'),
    alt: '有言提供超仿真的AI声音克隆',
  },
  {
    title: '步骤二：配置知识库和演讲内容',
    des: '使用AI生成或手动编辑知识库，输入演讲内容',
    path: getFeUrl('/youyan-platform/chat-ppt/tools/2.png?x-oss-process=image/format,webp'),
    alt: '有言的AI配音支持自定义编辑',
  },
];

const handler = () => {
  location.href = `${location.origin}/editor/page/chat`;
};
</script>

<style lang="scss" scoped>
.tow-steps {
  background: var(--x-back-3);
}
.tow-steps__feature {
  display: flex;
  align-items: center;
  gap: 40px;
  // width: 1200px;
  .edit-card {
    background: #fff;
  }
}
</style>
